import React, { Component } from 'react';

// Una mesa del torneo. La carga es POR CLIC EN ORDEN DE LLEGADA: se toca al 1º, después al 2º…
// y el último se completa solo. Así no existen posiciones repetidas ni huecos por construcción,
// en vez de tener que validarlos — y en una tablet del mostrador es más rápido que tipear.
//
// "Empataron" agrupa al siguiente con el anterior. Con la mesa ya completa el botón pasa a
// "Empatar los 2 últimos" y fusiona los dos últimos grupos: sin eso, el autocompletado del
// último jugador hace imposible marcar que empataron los dos que cierran la mesa, que es un
// resultado de lo más común.
//
// Los asientos vienen en ORDEN DE JUEGO (1º, 2º…), y la tarjeta lo dice arriba antes de cargar:
// el juez lo lee en voz alta y con eso eligen color (bases de Catan).
//
// Un asiento marcado "No vino" queda afuera de la carga: la mesa se juega con los que están.
class TournamentTableCard extends Component {

    constructor(props) {
        super(props);
        this.state = { groups: [], tie: false, saving: false, corrigiendo: false };
    }

    jugando = () => this.props.table.seats.filter((s) => s.outcome !== 'no_show')

    sentados = () => {
        const out = [];
        this.state.groups.forEach((g) => g.forEach((id) => out.push(id)));
        return out;
    }

    posiciones = () => {
        const pos = {};
        let slot = 1;
        this.state.groups.forEach((g) => { g.forEach((id) => { pos[id] = slot; }); slot += g.length; });
        return pos;
    }

    tocar = (participantId) => {
        const groups = this.state.groups.map((g) => g.slice());
        if (this.state.tie && groups.length) groups[groups.length - 1].push(participantId);
        else groups.push([participantId]);

        // al asignar el penúltimo, el que queda entra solo
        const puestos = [];
        groups.forEach((g) => g.forEach((id) => puestos.push(id)));
        const faltan = this.jugando().filter((s) => puestos.indexOf(s.participantId) === -1);
        if (faltan.length === 1) groups.push([faltan[0].participantId]);

        this.setState({ groups, tie: false });
    }

    empate = () => {
        const completa = this.sentados().length === this.jugando().length;
        if (!completa) { this.setState({ tie: !this.state.tie }); return; }
        const groups = this.state.groups.map((g) => g.slice());
        if (groups.length > 1) {
            const ultimo = groups.pop();
            groups[groups.length - 1] = groups[groups.length - 1].concat(ultimo);
            this.setState({ groups });
        }
    }

    deshacer = () => {
        const groups = this.state.groups.map((g) => g.slice());
        if (groups.length) {
            groups[groups.length - 1].pop();
            if (!groups[groups.length - 1].length) groups.pop();
        }
        this.setState({ groups, tie: false });
    }

    faltanPv = () => this.props.rawRequired && this.jugando().some((s) => {
        const v = this.state['raw_' + s.participantId];
        return v === undefined || v === null || v === '' || !Number.isFinite(Number(v)) || Number(v) < 0;
    })

    confirmar = async () => {
        const pos = this.posiciones();
        const results = this.jugando().map((s) => ({
            participantId: s.participantId,
            position: pos[s.participantId],
            rawScore: this.state['raw_' + s.participantId] === undefined || this.state['raw_' + s.participantId] === ''
                ? null : this.state['raw_' + s.participantId],
        }));
        this.setState({ saving: true });
        try {
            if (this.state.corrigiendo) {
                const hecho = await this.props.onCorrect(this.props.table.id, results);
                this.setState({ saving: false, ...(hecho ? { groups: [], tie: false, corrigiendo: false } : {}) });
                return;
            }
            await this.props.onReport(this.props.table.id, results);
            this.setState({ groups: [], tie: false, saving: false });
        } catch (e) {
            window.alert(e.message);
            this.setState({ saving: false });
        }
    }

    // Corregir una mesa cargada: con la ronda abierta, se vacía y se vuelve a cargar como siempre.
    // Con la ronda CERRADA, se edita acá mismo y el backend muestra primero qué cambia (quién entra
    // a la final, por ejemplo) antes de aplicarlo: son los siete pasos de antes en uno.
    empezarCorreccion = () => {
        if (!this.props.roundClosed) { this.props.onClear(this.props.table.id); return; }
        const raws = {};
        this.props.table.seats.forEach((s) => { raws['raw_' + s.participantId] = s.rawScore == null ? '' : String(s.rawScore); });
        this.setState({ corrigiendo: true, groups: [], tie: false, ...raws });
    }

    ordenDeJuego = () => {
        const conOrden = this.props.table.seats.filter((s) => s.seatOrder != null && s.outcome !== 'no_show');
        if (!conOrden.length) return null;
        return (
            <div style={{ fontSize: 12, color: '#3D5170', background: '#F4F8FF', borderRadius: '.25rem', padding: '6px 9px', marginBottom: 8, lineHeight: 1.5 }}>
                <strong>Orden de juego:</strong>{' '}
                {conOrden.slice().sort((a, b) => a.seatOrder - b.seatOrder).map((s) => `${s.seatOrder}º ${s.name}`).join(' · ')}
            </div>
        );
    }

    // Oro / plata / bronce: no es decoración, codifica el puesto de un vistazo, que es lo que
    // se lee en una mesa apurada.
    circulo = (p) => {
        const base = {
            width: 23, height: 23, borderRadius: '50%', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 500,
            border: '1px solid #E1E5EB', color: '#818EA3', background: '#FFF', flex: 'none',
        };
        if (p === 1) return { ...base, background: '#D4A017', borderColor: '#D4A017', color: '#FFF' };
        if (p === 2) return { ...base, background: '#9AA3AC', borderColor: '#9AA3AC', color: '#FFF' };
        if (p === 3) return { ...base, background: '#B0713C', borderColor: '#B0713C', color: '#FFF' };
        return base;
    }

    // El puntaje acumulado del jugador estaba acá y había que sacarlo: un "41 pts" al costado
    // del nombre, en la misma fila donde se carga el puntaje de ESTA mesa, se lee como si fuera
    // de la mesa. Dos números con el mismo aspecto y significados distintos es peor que no
    // mostrar el segundo.
    //
    // Queda el puesto en la tabla general, que sí orienta ("a este le está yendo bien"), pero en
    // otro idioma visual a propósito: pastilla gris chica con # contra el círculo lleno de color
    // del puesto en la mesa. Si se parecieran, volveríamos al mismo problema.
    rankChip = (s) => {
        const rank = this.props.rankById && this.props.rankById[s.participantId];
        if (!rank) return null;
        return (
            <span title={`Va ${rank}º en la tabla general`} style={{
                fontSize: 10.5, lineHeight: 1.5, color: '#A7AEB8', background: '#F5F6F8',
                border: '1px solid #EDEFF2', borderRadius: 10, padding: '0 6px', flex: 'none',
            }}>#{rank}</span>
        );
    }

    filaAsiento = (contenido, key) => (
        <div key={key} className="d-flex align-items-center" style={{
            gap: 9, border: '1px solid #E1E5EB', borderRadius: '.25rem',
            padding: '8px 10px', marginBottom: 6, fontSize: 13,
        }}>{contenido}</div>
    )

    renderCargada() {
        const { table } = this.props;
        const orden = table.seats.filter((s) => s.outcome !== 'no_show').sort((a, b) => a.position - b.position);
        return (
            <div className="card card-small mb-4" style={{ borderTop: '2px solid #17C671' }}>
                <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                    <h6 className="m-0">Mesa {table.number}</h6>
                    <span className="badge badge-success">Cargada</span>
                </div>
                <div className="card-body">
                    {orden.map((s) => this.filaAsiento(
                        <React.Fragment>
                            <span style={this.circulo(s.position)}>{s.position}</span>
                            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</span>
                            {s.rawScore != null ? <span style={{ color: '#818EA3', fontSize: 12 }}>{s.rawScore}</span> : null}
                            {s.points != null ? <span style={{ color: '#007BFF', fontWeight: 500 }}>+{s.points}</span> : null}
                        </React.Fragment>, s.seatId))}
                    {table.seats.filter((s) => s.outcome === 'no_show').map((s) => this.filaAsiento(
                        <React.Fragment>
                            <span style={this.circulo(null)}>–</span>
                            <span style={{ flex: 1, color: '#A7AEB8' }}>{s.name}</span>
                            <span className="badge badge-light">no vino</span>
                        </React.Fragment>, 'ns' + s.seatId))}
                    {this.props.readOnly ? null : (
                        <button type="button" className="btn btn-sm btn-white" onClick={this.empezarCorreccion}
                            title={this.props.roundClosed ? 'Corregir el resultado: antes de aplicarlo te muestra qué cambia' : ''}>
                            Corregir
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { table } = this.props;
        if (table.status === 'reported' && !this.state.corrigiendo) return this.renderCargada();

        const sentados = this.sentados();
        const pos = this.posiciones();
        const jugando = this.jugando();
        const completa = sentados.length === jugando.length;
        const faltanPv = this.faltanPv();
        const editableAsientos = !this.state.corrigiendo && !!this.props.onSeatOutcome && !sentados.length;

        return (
            <div className="card card-small mb-4" style={this.state.corrigiendo ? { borderTop: '2px solid #FFB400' } : null}>
                <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                    <h6 className="m-0">Mesa {table.number}</h6>
                    {this.state.corrigiendo ? (
                        <button type="button" className="btn btn-sm btn-white"
                            onClick={() => this.setState({ corrigiendo: false, groups: [], tie: false })}>Cancelar corrección</button>
                    ) : (
                        <span style={{ fontSize: 12, color: '#818EA3' }}>{jugando.length} jugadores</span>
                    )}
                </div>
                <div className="card-body">
                    {this.state.corrigiendo ? (
                        <div style={{ background: '#FFF8E8', borderRadius: '.25rem', padding: '7px 9px', fontSize: 12, marginBottom: 8, lineHeight: 1.4 }}>
                            Cargá el resultado correcto. Antes de guardar te mostramos qué cambia en el resto del torneo.
                        </div>
                    ) : this.ordenDeJuego()}
                    {table.sameGroup && table.sameGroup.length ? (
                        <div style={{ background: '#F5F6F8', borderRadius: '.25rem', padding: '7px 9px', fontSize: 12, marginBottom: 8, lineHeight: 1.4 }}>
                            Mismo grupo: {table.sameGroup.join('; ')} (no se pudo evitar)
                        </div>
                    ) : null}
                    {table.rematches && table.rematches.length ? (
                        <div style={{
                            background: '#FFF8E8', borderRadius: '.25rem', padding: '7px 9px',
                            fontSize: 12, marginBottom: 8, lineHeight: 1.4,
                        }}>
                            <strong style={{ color: '#97641A' }}>!</strong> Ya se cruzaron: {table.rematches.join('; ')}
                        </div>
                    ) : null}

                    {completa ? null : (
                        <div style={{ fontSize: 12, color: '#818EA3', marginBottom: 6 }}>
                            {sentados.length ? `¿Quién salió ${sentados.length + 1}°?` : 'Tocá en orden de llegada'}
                            {this.state.tie ? <span className="badge badge-primary ml-2">el próximo empata</span> : null}
                        </div>
                    )}

                    {/* Una sola lista. El puntaje acumulado vive a la derecha del nombre hasta que
                        tocás al jugador, y ahí MISMO se convierte en el campo del puntaje del juego.
                        Antes eran dos listas: se asignaban los puestos arriba y abajo aparecían los
                        mismos nombres otra vez con los campos. Duplicar la mesa para pedir un número
                        por jugador obliga a leerla dos veces y a buscar a cada uno en la segunda —
                        justo lo que no se puede hacer en el salón con la gente esperando. */}
                    {table.seats.filter((s) => s.outcome === 'no_show').map((s) => (
                        <div key={'ns' + s.seatId} className="d-flex align-items-center" style={{
                            gap: 9, border: '1px dashed #E1E5EB', borderRadius: '.25rem', padding: '7px 10px',
                            marginBottom: 6, fontSize: 13, color: '#A7AEB8',
                        }}>
                            <span style={{ flex: 1 }}>{s.name} · no vino</span>
                            {editableAsientos ? (
                                <button type="button" className="btn btn-sm btn-white py-0"
                                    onClick={() => this.props.onSeatOutcome(table.id, s.seatId, 'played')}>Vino</button>
                            ) : null}
                        </div>
                    ))}

                    {jugando.map((s) => {
                        const puesto = pos[s.participantId];
                        const listo = puesto !== undefined;
                        const pideRaw = listo && this.props.usesRawScore;
                        return (
                            <div key={s.seatId} className="d-flex align-items-center" style={{
                                gap: 9, border: '1px solid #E1E5EB', borderRadius: '.25rem',
                                padding: pideRaw ? '5px 8px 5px 10px' : '9px 10px',
                                marginBottom: 6, fontSize: 13,
                                background: listo ? '#FCFCFC' : '#FFF', color: '#5A6169',
                            }}>
                                <button type="button" disabled={listo}
                                    onClick={() => this.tocar(s.participantId)}
                                    className="d-flex align-items-center"
                                    style={{
                                        gap: 9, flex: 1, minWidth: 0, border: 'none', background: 'transparent',
                                        padding: 0, textAlign: 'left', color: 'inherit', font: 'inherit',
                                        cursor: listo ? 'default' : 'pointer',
                                    }}>
                                    <span style={this.circulo(puesto)}>{listo ? puesto : '·'}</span>
                                    {/* El chip va PEGADO al nombre, no contra el borde derecho: ahí
                                        cae el campo del puntaje de la mesa, y cualquier cosa que
                                        ocupe ese lugar antes se lee como si fuera de la mesa. */}
                                    <span className="d-flex align-items-center" style={{ flex: 1, minWidth: 0, gap: 6 }}>
                                        <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</span>
                                        {this.rankChip(s)}
                                    </span>
                                </button>
                                {editableAsientos && !listo ? (
                                    <span className="d-flex" style={{ gap: 4, flex: 'none' }}>
                                        <button type="button" className="btn btn-sm btn-white py-0 px-1" style={{ fontSize: 11 }}
                                            title="No se presentó: la mesa se juega sin él y no juega la próxima ronda hasta que lo marques presente"
                                            onClick={() => this.props.onSeatOutcome(table.id, s.seatId, 'no_show')}>No vino</button>
                                        {this.props.onWithdraw ? (
                                            <button type="button" className="btn btn-sm btn-white py-0 px-1" style={{ fontSize: 11 }}
                                                title="Abandonó a mitad de partida: queda último en esta mesa con los PV que tenía y no juega más"
                                                onClick={() => this.props.onWithdraw(s.participantId, s.name)}>Se fue</button>
                                        ) : null}
                                    </span>
                                ) : null}
                                {pideRaw ? (
                                    <input type="number" className="form-control" placeholder="pts"
                                        style={{ width: 78, padding: '4px 6px', fontSize: 13, textAlign: 'right', flex: 'none' }}
                                        value={this.state['raw_' + s.participantId] || ''}
                                        onChange={(e) => this.setState({ ['raw_' + s.participantId]: e.target.value })}
                                        aria-label={'Puntaje del juego de ' + s.name} />
                                ) : null}
                            </div>
                        );
                    })}

                    {/* Antes decía que el puntaje del juego era "opcional: no cambia los puntos del
                        torneo". En un torneo oficial de Catan los PV son el desempate 1 y 2 —con mesas
                        de 4 son los que ELIGEN a los finalistas—, y el staff los salteaba porque la
                        pantalla le decía que daba igual. */}
                    {this.props.usesRawScore && sentados.length ? (
                        <div style={{ fontSize: 12, color: this.props.rawRequired && faltanPv ? '#C4183C' : '#818EA3', marginBottom: 8 }}>
                            {this.props.rawRequired
                                ? 'Cargá los puntos de victoria de todos: son el desempate que elige a los finalistas.'
                                : 'Cargá el puntaje del juego: se usa para desempatar.'}
                        </div>
                    ) : null}

                    <div className="d-flex" style={{ gap: 7, marginTop: 8, flexWrap: 'wrap' }}>
                        <button type="button" className="btn btn-sm btn-white" onClick={this.empate}
                            disabled={!sentados.length || (completa && this.state.groups.length < 2)}>
                            {completa ? 'Empatar los 2 últimos' : (this.state.tie ? 'Cancelar empate' : 'Empataron')}
                        </button>
                        {sentados.length ? (
                            <button type="button" className="btn btn-sm btn-white" onClick={this.deshacer}>Deshacer</button>
                        ) : null}
                        <button type="button" className="btn btn-sm btn-accent ml-auto"
                            disabled={!completa || this.state.saving || faltanPv} onClick={this.confirmar}
                            title={faltanPv && completa ? 'Faltan puntos de victoria' : ''}>
                            {this.state.saving ? 'Guardando…' : this.state.corrigiendo ? 'Revisar corrección' : 'Confirmar mesa'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default TournamentTableCard;
